import type { ConversationDigestApiModel as ConversationSummary } from "@noa/api-core";
import { zodResolver } from "@hookform/resolvers/zod";
import { useRenameConversation } from "@noa/api-client";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

const renameSchema = z.object({ name: z.string().min(1) });
type RenameForm = z.infer<typeof renameSchema>;

export function useRenameConversationForm(conversation: ConversationSummary, isOpen: boolean, onSuccess: () => void) {
  const { mutate: renameConversation, isPending } = useRenameConversation();
  const form = useForm<RenameForm>({ resolver: zodResolver(renameSchema) });
  const { reset, handleSubmit } = form;

  useEffect(() => {
    if (isOpen) {
      reset({ name: conversation.name ?? "" });
    }
  }, [isOpen, conversation, reset]);

  const submit = handleSubmit((values) => {
    renameConversation(
      { sessionId: conversation.session_id, name: values.name },
      {
        onSuccess: () => {
          onSuccess();
          reset();
        },
      }
    );
  });

  const cancel = () => {
    onSuccess();
    reset();
  };

  return { ...form, submit, cancel, isPending };
}
